<template>
  <div id="app">
    <router-view></router-view>
    <!-- <transition name="main"  mode="out-in">
      <keep-alive>
          <router-view></router-view>
      </keep-alive>
  </transition> -->
  </div>
</template>

<script>
import config from '@/config/config.js'


export default {
  name: 'app',
  created() {
    // // config.initConfig(window.location.hostname);
    // config.initConfig('hsedu.hnztaqkj.com');
    // document.title = config.platformName;
    // document.getElementById('favicon').href = config.images.logoImage;
    // // document.getElementById('favicon').href = '/static/oem/hsgz/img/logo.jpg';

  },

}
</script>

<style>
/*body .el-table th.gutter {*/
/*  display: table-cell !important;*/
/*}*/

.pageNum {
  text-align: right;
}

html,body{
  height: 100%;
  position: relative;
  background-color: #F1F1F1;
  /*background-color: #F3F4F8;*/
  padding:0px;
  margin:0px auto;
  overflow: auto !important;
}
a{
  text-decoration:none;
}
#app {
  height: 100%;
  /*overflow: hidden;*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: left;*/
  /*color: #2c3e50;*/
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.body {
  height: 100%;
  /*height: 800px;*/
  background: #f5f5f5;
  padding: 0px 15px;
  /*border-radius: 8px;*/
  overflow-y: auto;
}
.bodys{
  background-color: #FFFFFF;
}
.body-title {
  line-height: 50px;
  margin-bottom: 30px;
  position: relative;
}
.body-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  background: #99999920;
  height: 2px;
  width: 100%;
}
.bg-color {
  background: #f5f5f5;
}
.bg-white {
  background: white;
}
.color-blue {
  color: #5D8C82;
}
.color-red {
  color: red;
}
/* flex布局 */
.f {
  display: flex;
  background-color: #FFFFFF;
}
.f1 {
  flex: 1;
}
.f-c {
  display: flex;
  justify-content: center;
}

.f-b {
  display: flex;
  justify-content: space-between;
}

.f-b-c {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.f-a {
  display: flex;
  justify-content: space-around;
}
.f-a-c {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.f--c {
  display: flex;
  align-items: center;
}

.f-c-c {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fw-n {
  flex-wrap: nowrap;
}

.fw-w {
  flex-wrap: wrap;
}

.fd-c {
  flex-direction: column;
}

/* 单行文本超出省略号 */
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 多行文本超出省略号 */
.ellipsis2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.mb10 {
  margin-bottom: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.mb30 {
  margin-bottom: 30px;
}
.mr10 {
  margin-right: 10px;
}
.mr20 {
  margin-right: 20px;
}
.mr30 {
  margin-right: 30px;
}

.pr10 {
  padding-right: 10px;
}
.pr20 {
  padding-right: 20px;
}
.pr30 {
  padding-right: 30px;
}

.p10 {
  padding: 10px;
}
.p20 {
  padding: 20px;
}
.p30 {
  padding: 30px;
}
.pb50{
  padding-bottom: 50px;
}



/*解决 element ui drawer组件不显示下拉条bug*/
.el-drawer__body {
  overflow: auto;
}


.el-table .cell.el-tooltip {
  white-space: nowrap!important;
  min-width: 50px;
}


.operationControl {
  border-bottom: 1px solid #f5f5f6;
  margin-bottom: 2px;
}


.el-popover {
  z-index: 30000 !important;
}

/*.el-scrollbar .el-scrollbar__view {*/
/*  height: auto;*/
/*  max-height: 274px;*/
/*  padding: 0;*/
/*  line-height: 28px;*/
/*  overflow: hidden;*/
/*  overflow-y: auto;*/
/*}*/

.el-tooltip__popper {
  z-index: 2000000000 !important;
}

</style>





// WEBPACK FOOTER //
// src/App.vue